/* Frequencify reviews — opens/closes the card dialogs (video, screenshot, full story).
   Used by sections/fq-reviews.liquid. Native <dialog>; no dependencies.
   - Shopify videos are paused and rewound on close.
   - YouTube/Vimeo iframes only get their src when opened, and lose it on close
     (stops playback and avoids loading third-party players until requested). */
(function () {
  if (window.fqReviewsInit) return;
  window.fqReviewsInit = true;

  var lastTrigger = null;

  function open(dialog, trigger) {
    if (!dialog || typeof dialog.showModal !== 'function') return;
    lastTrigger = trigger || null;
    dialog.querySelectorAll('iframe[data-src]').forEach(function (f) {
      if (!f.getAttribute('src')) {
        var src = f.getAttribute('data-src');
        f.setAttribute('src', src + (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1');
      }
    });
    dialog.showModal();
    document.body.classList.add('fq-rv-locked');
    var video = dialog.querySelector('video');
    if (video) {
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }
  }

  function onClose(e) {
    var dialog = e.target;
    dialog.querySelectorAll('video').forEach(function (v) { v.pause(); try { v.currentTime = 0; } catch (err) {} });
    dialog.querySelectorAll('iframe[data-src]').forEach(function (f) { f.removeAttribute('src'); });
    document.body.classList.remove('fq-rv-locked');
    if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
    lastTrigger = null;
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-fq-rv-open]');
    if (trigger) {
      e.preventDefault();
      open(document.getElementById(trigger.getAttribute('data-fq-rv-open')), trigger);
      return;
    }
    if (e.target.closest('[data-fq-rv-close]')) {
      var d = e.target.closest('dialog');
      if (d) d.close();
      return;
    }
    // click on the backdrop (outside the dialog box) closes it
    if (e.target.matches && e.target.matches('dialog.fq-rv-dialog[open]')) {
      var r = e.target.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) e.target.close();
    }
  });

  function bind(root) {
    (root || document).querySelectorAll('dialog.fq-rv-dialog').forEach(function (d) {
      if (d.dataset.fqRvBound) return;
      d.dataset.fqRvBound = '1';
      d.addEventListener('close', onClose);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { bind(); });
  else bind();
  // theme editor re-renders sections
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
})();
